// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.dropdown-list {
  margin-top: -36px;
  padding-top: 36px;
  position: relative;
}

.select-list {
  border-radius: 0 0 6px 6px;
  border-radius: 0 0 6px 6px;
  border-radius: 0 0 6px 6px;
  border-radius: 0 0 6px 6px;
  border-radius: 0 0 6px 6px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);
  display: none;
  background-color: hsl(0, 0%, 95%);
  border: 1px solid #d2d2d2;
  border-top: 0;
  max-height: 320px;
  overflow-y: auto;
  padding: 10px 0 0;
  position: absolute;
  width: 100%;
  z-index: 1000;
}
.select-list li {
  height: 36px;
  line-height: 40px;
  overflow: hidden;
  padding: 0 15px;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 1000;
}
.select-list li:hover, .select-list li.selected, .select-list li:focus {
  background-color: #d2d2d2;
  cursor: pointer;
  outline: none;
}
.select-list.open {
  display: block;
  z-index: 1;
}

.selectWrap {
  border-radius: 6px;
  border-radius: 6px;
  border-radius: 6px;
  border-radius: 6px;
  border-radius: 6px;
  -webkit-appearance: none; /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
  background: linear-gradient(to bottom, #f2f2f2 0%, #fcfcfc 100%);
  border: 1px solid #d2d2d2;
  box-shadow: 2px 3px 2px -2px rgba(0, 0, 0, 0.08) inset;
  color: #191919;
  display: inline-block;
  height: 36px;
  line-height: 36px;
  padding: 0 15px;
  position: relative;
  transition: border 300ms linear 0ms;
  vertical-align: middle;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.selectWrap::after {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  color: hsl(204.9, 94.4%, 35.1%);
  display: inline-block;
  font: 20px "icoPrimary" !important;
  height: 17px;
  line-height: 1;
  position: absolute;
  right: 15px;
  top: 7px;
  user-select: none;
  vertical-align: middle;
  width: 11px;
  transform: none !important;
}
.selectWrap.open {
  border-radius: 6px 6px 0 0;
  border-radius: 6px 6px 0 0;
  border-radius: 6px 6px 0 0;
  border-radius: 6px 6px 0 0;
  border-radius: 6px 6px 0 0;
  background: linear-gradient(to bottom, hsl(0, 0%, 95%) 0%, hsl(0, 0%, 95%) 100%);
  background: -webkit-linear-gradient(top, hsl(0, 0%, 95%) 0%, hsl(0, 0%, 95%) 100%);
  background-color: hsl(0, 0%, 95%);
  border-color: hsl(204.9, 94.4%, 35.1%);
  transition: border 0.3s linear 0s;
}
.selectWrap.open::after {
  transform: rotate(180deg) !important;
}
.selectWrap .dropDownLabel {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/lib/ng2-sapmp/src/ui-components/dropdown/dropdown.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AAmJF;;AAhJA;EF4BI,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,2CAAA;EAAA,2CAAA;EAAA,2CAAA;EAAA,2CAAA;EAAA,2CAAA;EEzBF,aAAA;EACA,iCAAA;EACA,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AA2JF;AAzJE;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AA2JJ;AAzJI;EAGE,yBAAA;EACA,eAAA;EACA,aAAA;AAyJN;AArJE;EACE,cAAA;EACA,UAAA;AAuJJ;;AAnJA;EFXI,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEaF,wBAAA,EACA,0BAAA,EACA,2BAAA,EACA,0BAAA;EACA,gEAAA;EACA,yBAAA;EACA,sDAAA;EACA,cAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,mCAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;AA0JF;AAxJE;EACE,mCAAA;EACA,kCAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kCAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EAEA,0BAAA;AAyJJ;AAtJE;EFrDE,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EEuDA,gFAAA;EACA,kFAAA;EACA,iCAAA;EACA,sCAAA;EACA,iCAAA;AA4JJ;AA3JI;EACE,oCAAA;AA6JN;AA1JE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;AA4JJ","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../assets/style/mixinfunction';\n\n.dropdown-list {\n  margin-top: -36px;\n  padding-top: 36px;\n  position: relative;\n}\n\n.select-list {\n  @include vendor-prefix('border-radius', 0 0 6px 6px);\n  @include vendor-prefix('box-shadow', 1px 1px 2px rgba(0, 0, 0, .15));\n  display: none;\n  background-color: color(default, base);\n  border: 1px solid color(default, dark);\n  border-top: 0;\n  max-height: 320px;\n  overflow-y: auto;\n  padding: 10px 0 0;\n  position: absolute;\n  width: 100%;\n  z-index: 1000;\n\n  li {\n    height: 36px;\n    line-height: 40px;\n    overflow: hidden;\n    padding: 0 15px;\n    position: relative;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    z-index: 1000;\n\n    &:hover ,\n    &.selected,\n    &:focus {\n      background-color: color(default, dark);\n      cursor: pointer;\n      outline: none;\n    }\n  }\n\n  &.open {\n    display: block;\n    z-index: 1;\n  }\n}\n\n.selectWrap {\n  @include vendor-prefix('border-radius', 6px);\n  -webkit-appearance: none;\n  background: -webkit-linear-gradient(to bottom, #f2f2f2 0%, #fcfcfc 100%); /* For Safari 5.1 to 6.0 */\n  background: -o-linear-gradient(to bottom, #f2f2f2 0%, #fcfcfc 100%); /* For Opera 11.1 to 12.0 */\n  background: -moz-linear-gradient(to bottom, #f2f2f2 0%, #fcfcfc 100%); /* For Firefox 3.6 to 15 */\n  background: linear-gradient(to bottom, #f2f2f2 0%, #fcfcfc 100%);\n  border: 1px solid color(default, dark);\n  box-shadow: 2px 3px 2px -2px rgba(0, 0, 0, 0.08) inset;\n  color: color(inverse, darker);\n  display: inline-block;\n  height: 36px;\n  line-height: 36px;\n  padding: 0 15px;\n  position: relative;\n  transition: border 300ms linear 0ms;\n  vertical-align: middle;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &::after{\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    color: color(secondary, base);\n    display: inline-block;\n    font: 20px 'icoPrimary' !important;\n    height: 17px;\n    line-height: 1;\n    position: absolute;\n    right: 15px;\n    top: 7px;\n    user-select: none;\n    vertical-align: middle;\n    width: 11px;\n    // z-index: 666;\n    transform: none !important;\n  }\n\n  &.open {\n    @include vendor-prefix('border-radius', 6px 6px 0 0);\n    background: linear-gradient(to bottom, color(default, base) 0%, color(default, base) 100%);\n    background: -webkit-linear-gradient(top, color(default, base) 0%, color(default, base) 100%);\n    background-color: color(default, base);\n    border-color: color(secondary, base);\n    transition: border .3s linear 0s;\n    &::after{\n      transform: rotate(180deg) !important;\n      }\n  }\n  .dropDownLabel {\n    position: absolute;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    width: 1px;\n    margin: -1px;\n    padding: 0;\n    border: 0;\n  }\n}\n\n \n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
